import Store from '@store';
import TextOverflowApp from 'src/views/text-overflow/text-overflow.jsx';

const menus = {
  'header-and-footer': {
    name: INKIVE.TranslateHelper.translate('top_submenu.frame.layout.header_and_footer'),
    className: 'context-menu-header-footer',
    callback: () => INKIVE.EditorFacade.handle('header_and_footer', 'open', {
      type: 'headerAndFooter'
    }),
    toggleDisabled: () => false
  },
  textOverflow: {
    name: INKIVE.TranslateHelper.translate('top_submenu.frame.layout.text_overflow'),
    className: 'context-menu-text-overflow',
    callback: async () => {
      await TextOverflowApp.mountApp();
      TextOverflowApp.openTextOverflow();
    },
    toggleDisabled: () => false
  },
  'table-of-contents': {
    name: INKIVE.TranslateHelper.translate('top_submenu.table_of_contents_modal.title'),
    className: 'context-menu-table-of-contents',
    callback: () => tableOfContentsEvent(),
    toggleDisabled: () => false
  }
};

function tableOfContentsEvent () {
  const dropdown = document.querySelector('header .ui-dropdown-content[data-id="table-of-contents"]');
  INKIVE.EditorFacade.handle('table_of_contents', 'show', {
    element: dropdown
  });
}

const handleMenuOption = (key, options, event) => {
  if (!(key in menus)) {
    console.error('Unknown menu option:', key);
  }

  menus[key].callback(event);
};

const getMenuPosition = () => ({
  top: document.querySelector('header').offsetHeight + 6,
  left: document.querySelector('[data-action=file]').getBoundingClientRect().left
});

function createContextMenu (button, menus) {
  const showTextOverflow = INKIVE.C.SHOW_TEXT_OVERFLOW;
  if (!showTextOverflow) {
    delete menus.textOverflow;
  }

  const selector = '[data-action="layout"]';

  $.contextMenu({
    selector,
    trigger: 'left',
    hideOnSecondTrigger: true,
    events: {
      hide: () => {
        const menu = document.querySelector(selector);
        menu.classList.remove('context-menu-active');
        menu.blur();
        return true;
      }
    },
    position: (opt) => {
      opt.$menu.css(getMenuPosition());
    },
    build: ($button) => {
      $button.one('contextmenu:visible', () => {
        const contextMenu = document.querySelector('.context-menu-root');

        Object.entries(menus).forEach(([key, { className, toggleDisabled }]) => {
          const menu = contextMenu.querySelector(`.${className}`);
          menu.classList.toggle('disabled', toggleDisabled());
          menu.dataset.action = key;
        });
      });

      return {
        callback: handleMenuOption,
        items: menus
      };
    }
  });
}

export default function createLayoutButton () {
  const showLayout = INKIVE.C.SHOW_LAYOUT;
  if (!showLayout) return;

  const layoutButton = document.querySelector('header .menus [data-action="layout"]')?.parentElement;
  if (layoutButton) return createContextMenu(layoutButton, menus);

  const container = document.createElement('div');
  container.innerHTML = `<li class="desygner-dropdown-menu">
    <button class="desygner-clear-button" data-action="layout">
    ${INKIVE.TranslateHelper.translate('top_submenu.frame.layout.button')}
    </button>
  </li>`;
  const button = container.firstChild;

  const referenceNode = document.querySelector('header .menus [data-action="file"]')?.parentNode;

  if (referenceNode) {
    referenceNode?.parentNode?.insertBefore(button, referenceNode.nextElementSibling);
    createContextMenu(button, menus);
  }
}
